'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
export function Dropdown(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Headless.Menu {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}